import request from '@/utils/request'

/**
 * spu列表
 * @param {*} params 
 */
export function fetchSpuList(params) {
    return request({
        url: '/StockProductInfo/Search',
        method: 'post',
        data: params
    });
}


export function fetchSpuDetail(id) {
    return request({
        url: '/StockProductInfo/' + id,
        method: 'get'
    });
}


export function fetchBillCode(code) {
    return request({
        url: '/StockProductInfo/GetBillCode?Code=' + (code || ""),
        method: 'get'
    });
}

export function delSpu(id) {
    return request({
        url: '/StockProductInfo/' + id,
        method: 'delete'
    });
}

export function fetchSkuDictAll() {
    return request({
        url: '/StockProductInfo/DictAll',
        method: 'get',
        cache: 60 * 60 * 24 * 7
    });
}

export function fetchSkuDictList(code = '') {
    return request({
        url: '/StockProductInfo/DictList',
        method: 'get',
        params: { code },
        cache: 60 * 60 * 24 * 7
    });
}

/**
 * 修改产品SPU信息
 * @param {*} params 
 * @returns 
 */
export function submitSpu(id, params) {
    return request({
        url: '/StockProductInfo/' + (id || ''),
        method: id ? 'put' : 'post',
        data: params
    });
}



export function searchSkuList(queryString) {
    const searchParams = {
        page: 1,
        rows: 20,
        columns: [
            { prop: "category", searchable: true },
            { prop: "detailCode", searchable: true },
            { prop: "detailName", searchable: true },
            { prop: "serialCode", searchable: true },
            { prop: "brandName", searchable: true },
            { prop: "brandModelCode", searchable: true },
            { prop: "detailUnit" },
            { prop: "factoryName" },
            { prop: "factoryCode" },
            { prop: "factoryModelCode" },
        ],
        keyword: queryString.trim()
    };

    return request({
        url: '/StockProductDetail/Search',
        method: 'post',
        data: searchParams
    });
}


/**
 * sku列表
 * @param {*} params 
 */
export function fetchSkuList(params) {
    return request({
        url: '/StockProductDetail/Search',
        method: 'post',
        data: params
    });
}


export function fetchSkuDetail(id) {
    return request({
        url: '/StockProductDetail/' + id,
        method: 'get'
    });
}

export function fetchSkuByDetailCode(DetailCode) {
    return request({
        url: '/StockProductDetail/DetailCode/' + DetailCode,
        method: 'get'
    });
}

/**
 * 修改产品SKU信息
 * @param {*} params 
 * @returns 
 */
export function submitSku(params) {
    let id = (params.id || '');
    return request({
        url: '/StockProductDetail/' + id,
        method: id.length > 0 ? 'put' : 'post',
        data: params
    });
}


export function delSku(id) {
    return request({
        url: '/StockProductDetail/' + id,
        method: 'delete'
    });
}


export function fetchDetailCode(params) {
    return request({
        url: '/StockProductDetail/GetBillCode',
        method: 'get',
        params: params
    });
}

/**
 * SKU批量上下架
 * @param {Array<string>} ids
 * @param {boolean} enabled
 */
export function batchSkuStatus(ids, enabled) {
    return request({
        url: '/StockProductDetail/BatchStatus',
        method: 'post',
        data: {
            Ids: ids,
            enabled: !!enabled
        }
    });
}

/**
 * SKU供应商报价
 */
export function fetchSkuSuppliers(params) {
    return request({
        url: '/StockProductSupplier/Search',
        method: 'post',
        data: params
    });
}

export function submitSkuSupplier(params) {
    const id = params.id || '';
    return request({
        url: '/StockProductSupplier/' + id,
        method: id ? 'put' : 'post',
        data: params
    });
}

export function deleteSkuSupplier(id) {
    return request({
        url: '/StockProductSupplier/' + id,
        method: 'delete'
    });
}

/**
 * 组合产品
 */
export function fetchSkuCombos(params) {
    return request({
        url: '/StockProductCombo/Search',
        method: 'post',
        data: params
    });
}

export function submitSkuCombo(params) {
    const id = params.id || '';
    return request({
        url: '/StockProductCombo/' + id,
        method: id ? 'put' : 'post',
        data: params
    });
}

export function deleteSkuCombo(id) {
    return request({
        url: '/StockProductCombo/' + id,
        method: 'delete'
    });
}



export function getPrevID() {
    return request({
        url: '/StockProductInfo/PrevID',
        method: 'get',
    }).then((res) => {
        return res.data;
    });
}
